export default __webpack_public_path__ + "static/media/icn-acceleration-vehicle.c94f58b9.svg";